import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const ContainerBig = styled.div `
    margin-left: 0px;
    margin-right: 0px;
    padding: 0px;
`;

export const DescriptionTitle = styled.span `
    color: ${ getTheme('textColor') };
    display: inline-block;
    font-size: 11px;
    font-weight: lighter;
    margin: 0;
    margin-top: 10px;
    opacity: 0.6;
    text-align: center;
`;

export const DescriptionData = styled.span `
    color: ${ getTheme('textColor') };
    font-size: 11px;
    margin: 0px;
    margin-left: 5px;
    word-break: break-all;
`;
